import React from "react";
import styled from "styled-components";
import { tokens } from "../../../public/tokens";

const TAG_VARIANTS = {
  success: {
    backgroundColor: tokens.colors.states.success.default,
    color: tokens.colors.neutral.white,
  },
  warning: {
    backgroundColor: tokens.colors.states.warning.default,
    color: tokens.colors.neutral.white,
  },
  error: {
    backgroundColor: tokens.colors.states.alert.default,
    color: tokens.colors.neutral.white,
  },
  info: {
    backgroundColor: tokens.colors.states.info.default,
    color: tokens.colors.neutral.white,
  },
  required: {
    backgroundColor: tokens.colors.states.alert.default,
    color: tokens.colors.neutral.white,
  },
};
    const TagContent = styled('span', {
      shouldForwardProp: (prop) => !['color'].includes(prop),
    })`
     
      text-box-trim: trim-both;
      text-transform: uppercase;
      font-family:  ${tokens.globals["font-family"]};
      font-size: ${tokens.typography.fontSize["md-12px"]};
      text-align: center;
      margin: 0;
      font-weight: ${tokens.typography.fontWeights.bold};
      line-height: ${tokens.typography.lineHeights[100]}; ;
      color: ${props => props.color};
    `;

    const TagWrapper = styled('div', {
      shouldForwardProp: (prop) => !['color', 'backgroundColor'].includes(prop),
    })`
      display: inline-flex;
      align-items: center;
      align-content: center;
      flex-direction: row;
      justify-content: center;
      padding: 3px 5px;
      height: 17px;
      min-width: fit-content;
      width: fit-content;
      border-radius: ${tokens.globals["border-radius"]};
      overflow: hidden;
      margin: 0;
      white-space: nowrap;
      background-color: ${props => props.backgroundColor};
      color: ${props => props.color};
    `;


function Tag({ children, variant = "success", text, style = {} }) {
  const variantStyles = TAG_VARIANTS[variant] || TAG_VARIANTS.success;
  const displayText = text || children;

  return (
    <TagWrapper 
      backgroundColor={variantStyles.backgroundColor}
      color={variantStyles.color}
      style={style}
    >
      <TagContent color={variantStyles.color}>
      {displayText}
      </TagContent>
      
    </TagWrapper>
  );
}

export default Tag;

